export default __webpack_public_path__ + "static/media/vyrill_logo_with_text.ded44798.png";